// extracted by mini-css-extract-plugin
module.exports = {"section":"PlanSpacesSection_section__BLVNU","header":"PlanSpacesSection_header__Rm2zx","title":"PlanSpacesSection_title___DfbH"};